
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as sortNYmoBQl_45sHCVoKp8Z3_AomLeHD1wEoV2VJcgyCyZj4gMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/sort.vue?macro=true";
import { default as brandPWC_45FBDR1SS25JRG1_45ANDjRpa5JmDOAnUv1diuiK_1IMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/brand.vue?macro=true";
import { default as indexaGHiWLhr8sPH5xOyniSbm5iVFqgM3tFusiL4jcFgWfQMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/index.vue?macro=true";
import { default as eventsWe0_FsIS5ciOkTkrC9ALXKM3kzO7Qtd1jFd1eKFRNNoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/events.vue?macro=true";
import { default as inviteD2we1_muU9VbMf8HKW2ke0iJCc6RNWEAxVtl3pnqNtMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/invite.vue?macro=true";
import { default as uploadgrqZX_45b6NpJX4rUI_NCLFdgkhBBXa02QOWiw40_Fv3oMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/upload.vue?macro=true";
import { default as faqkNxIdEYGbPo0JJj8oKPd00YUIwg91o_MVhYFZosOM0MMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/faq.vue?macro=true";
import { default as pxmik3drb5br7WbSAEVub8oqWd3dDTErxB5jaz52Jl_OQMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/test/px.vue?macro=true";
import { default as book3TGFzpm_Bbu0j5hu_pz9qbDJO3iQTmxpBjCSzmzMUZIMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/book.vue?macro=true";
import { default as helpa1Bx8KU55povpFbRJ8F6NanZ8KqdClrMlKeP5A9Sx5oMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/help.vue?macro=true";
import { default as homervSDKEmgo0_45A1_45mRlTiprdZOqrJbxWANUe9OHB3FSHgMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/home.vue?macro=true";
import { default as idea1ZE_AQQ6so8VSaWaKrTVmJMsVTIPTRXhBSH12ujg9E_45EMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/idea1.vue?macro=true";
import { default as indexhPsh2VWbeLxtxlgXbjhu8Ln_AxNSPdmakqOhD71rFd0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/index.vue?macro=true";
import { default as loginfAKFbx2kWILssxYhlKfgbTwYonPW1krvVt0DUZvKw_8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/login.vue?macro=true";
import { default as blobmFWETYb77oxZnHgBAfyWJOiZmDhi15UsoFHYlh_45__3IMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/test/blob.vue?macro=true";
import { default as contactjG6VmRZvfQe9LnnYAnjHFbl12lxZ3V0a5rKmBb2_45nCMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/contact.vue?macro=true";
import { default as desktopWzEIh2yaDof4IUJWLXJrRjehGLt9TBsNZlXjWCit_p0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/desktop.vue?macro=true";
import { default as profilegTx7VoT_451wzPyfZ_Hx1z32EhTgSR0iKLPXznCqRVtsoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/profile.vue?macro=true";
import { default as settingyOZOogW6_qbLKVhrkXUC69qfdlHezQITffAKlv3XL7AMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/setting.vue?macro=true";
import { default as faqeytPGKUb2n_t_3xGITy2AvZhlFn1N2NRBeGSm9u6AJ4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/faq.vue?macro=true";
import { default as invite_32copyvLQmDD39B1RovhD6YyJ_E8FsHxmg74c3vxob_45f2D5PUMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/invite copy.vue?macro=true";
import { default as producebookLb478lddzsG4df0O4e1mmlNTMnHqNjiyQQAUJYOREO4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/producebook.vue?macro=true";
import { default as helpXa19pqxp6xjWTK7pvUYakX_45D8XLyQe6HoFRTyytaLkEMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/help.vue?macro=true";
import { default as sortVTRAffZw7axLCJdEBhz_vFFbuV1bvLbUSGZz6xhJoeIMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/sort.vue?macro=true";
import { default as edit_45dataXvfX9F0sUjkbXvcjGbs49IVEkjZz3CpkcPxcbWSZ6zYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/edit-data.vue?macro=true";
import { default as listeMzLeHiyJp7BY15R3NPvnk9jRp5e1TcAXNJ6_iZOyYsMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/list.vue?macro=true";
import { default as mainbkvfgkst75djnkGv74YL4CYpiDU753nboFvGH8_45ydfcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/main.vue?macro=true";
import { default as register7TSjDF_45BFQ6OSe8w67HVtkHdTwFtWRSOdIiXVmgUM9QMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/register.vue?macro=true";
import { default as validatecAvqmc5LGwrTf5k3ChBUf_45xFe3hUgi5zM22IrYiCfWwMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/validate.vue?macro=true";
import { default as eventKUs6Jyw4ttM4FKXbhX3oPzF18KwNXpdRBfQodt6QFnAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/event.vue?macro=true";
import { default as indexAuKZ1Ndl3ZymFE8NMTxZF4vzJFXsR57iKThIXEKiJlsMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/index.vue?macro=true";
import { default as login0PVJcpWRt4FSMMmoYP_45EW_GFGxlovWT3zFFo6V0EziMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/login.vue?macro=true";
import { default as shareQAW7aJPRFCb0gP_o9HxtbJiSixxAcdP6u_69skBefncMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/share.vue?macro=true";
import { default as slideYLBpaLp48LdLUmFGGDnu5uF50T7FDOGaf9O65tpu2d8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/slide.vue?macro=true";
import { default as termsyjRU9tv4u2KvyA3lQ_45gG8toK2QPBar3ADb2B1AG7KYAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/terms.vue?macro=true";
import { default as priceeWJeARwYFcdJ7uj_45_Oa0mMntfGqIkcLaKIqyeKShSeUMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/package/price.vue?macro=true";
import { default as home_45spareSC3mgT_vmZ8aDUy5u_P8_D4gtYhMuOjS45QAckMTbgYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/home-spare.vue?macro=true";
import { default as how_45to_45useNUq0okB8ZRty4RbmFFtjWsj_7Ugd5xf9DXbZ00_45YKzkMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/how-to-use.vue?macro=true";
import { default as index4sbcDOl2Z4fYGIrOK6zf0dWujrJGX6djNrknJWEEACMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/index.vue?macro=true";
import { default as uploadmQwtN2tQdMWdL5MwT0sYgGAs7OBX31_tQqyi75oy9HAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/upload.vue?macro=true";
import { default as wishesWWKwQRfMTxNakE_45gmzj7fiM_f19aqWVwbdvMtIkktBcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/wishes.vue?macro=true";
import { default as invite_45userTDV7LeoupHxsFjzyV1t_45ipQ9_45a_hIYQZ2nxcjrTdGwgMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/invite-user.vue?macro=true";
import { default as line_45notifyDcpamDmWSZWhKpPJdywH4o8nruiib8qKL2K861pIsPAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/line-notify.vue?macro=true";
import { default as qrcodeJ_457CWrGq9a9gxV5Yqr0DPqXVxgjw6LO9EeKKNPzj5y8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/qrcode.vue?macro=true";
import { default as contactixuVJnsB2aBmcPc5J6QlseQY0GOZArPGMomR0PjRGvAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/contact.vue?macro=true";
import { default as settingV_hKxKwSUD1I9HsAZ8djbdkBkcvrXFLp7DgnrfC2jjkMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/setting.vue?macro=true";
import { default as exmaple_45formgHcwoCmVAlO_rKCCH0Th14ANyfdb6ilEuFf8Xholzu4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/exmaple-form.vue?macro=true";
import { default as create_45user7HkM_53i9GMpi5bYzt66ooFR23LqL4ZsGl2mX1P3WF8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/create-user.vue?macro=true";
import { default as login_45mobileGfZ06kfSnN6__450LyfjRryvPEw61FSVwViJDERbvq2WoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/login-mobile.vue?macro=true";
import { default as edit_45dataVcyFsGnZ7RojzWqIhnQu7dvA9l2zBdqAVN3lDDdMfMoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/edit-data.vue?macro=true";
import { default as promptpay8tzl1fnNTnFst6JesAg2c12Ex70CQMJEtKf_455m3OC0cMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/promptpay.vue?macro=true";
import { default as templatestdWOMw2BS9olDv7oJ2QB32RSITSNZ9EEdstBgq7xYMAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/templates.vue?macro=true";
import { default as indexrgMmzK0ZivvcDO5JUL6iX8Ira2jZ92I41vDfKwKjEJ4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/index.vue?macro=true";
import { default as eventsWhLd9sMRgTDyeQoBznlVIr7til4bRaIuvvLRWJ0s2AcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/events.vue?macro=true";
import { default as faqspUkYoka0XLcm9ZTpkXGm4ljWEGIGp8POVyaiE3vTBsYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/faqs.vue?macro=true";
import { default as listekvk7QFdR_45tTgCta_45AQ8VF4gmCNdX37K3PUFpG898VoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/list.vue?macro=true";
import { default as mainr6OXiyQXXBelanBVcbnnIw_45r9052tqa_45DhRsRKTJLGIMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/main.vue?macro=true";
import { default as showbJ3wNRgDA2QQukQlJwZOxYysH0RiqiS0NHIm78cpaHwMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/show.vue?macro=true";
import { default as indexiQUal72AWM10CtAt3Xj_DRSwPuYthTmbEQZMPoQ6sDcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/timeline/index.vue?macro=true";
import { default as pairEvent7Wu6kxmwDwQswy0vxF3Gzchh_941Y_7dbsHajAD7XpYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/pairEvent.vue?macro=true";
import { default as templatesP08KXD2_8VWc1NYWcMnyMzvGNpcPyEJy0TidzCqp0scMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/templates.vue?macro=true";
import { default as how_45to_45useYvApndS_K0VUmsM_45BTjqcKYKPxKV3iVVf0neWZQQ_qYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/how-to-use.vue?macro=true";
import { default as wisheslIeJ4McZLBnIl3lIvAn5E0u9q5l3CFCHmhzFEcWCAlEMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/wishes.vue?macro=true";
import { default as indexfhnsE5XKStPOxI22t3TEVqn8eO1M8_7sh1WWxBLFjqoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/index.vue?macro=true";
import { default as linkQrcodevJI7pjO3ovYsuweYvIiWDq2oLecB6cuhSr75Q37_45Is4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/linkQrcode.vue?macro=true";
import { default as producebookrrBMiGaMl0Xw4aKmIqd2RPViRWMP1ViER2C2BqgAnoQMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/producebook.vue?macro=true";
import { default as edit_45data_45customaB_r4VKauiPZvJ4ycYwggYtT6seo5wR0kr9k_aZWcZ0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/edit-data-custom.vue?macro=true";
import { default as qrcodeUonxSvWx6CLUS8xWpFG62LHXsF7qYD17_HmUJbSjrh0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/qrcode.vue?macro=true";
import { default as welcomePageWkj_45HcUiKFqrF2Umip75BIk9w7bMVZz_HXm0pT8mIJsMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/welcomePage.vue?macro=true";
import { default as wishes_45sparej117g29Aq7iQMA0yEgCOzhrecbYWtpJxB5LWk6dr45oMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/wishes-spare.vue?macro=true";
import { default as favoriteGWKx4xf2QIr2RUec1qzcwyIoRwNf31xamB2YH5vXOqIMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/favorite.vue?macro=true";
import { default as form8eHCsMbWPkhz2prMvTUH_X_45ccAz28h9Jl1ZzX3ljY2UMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/form.vue?macro=true";
import { default as showV77SbtYbRvpKb84GmA8YsN7tujHZj8g1SuE_4506N7i48Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/show.vue?macro=true";
import { default as thankyouPageDLmUFIuXacaLZVA5a7ZoPBU8lu1cqIXjhX1koGIy5PwMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/thankyouPage.vue?macro=true";
import { default as indexWxwGVd3VNWAk_45WufdvjNdqaEmZ1MYp0kJJHVxTEvbuQMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/index.vue?macro=true";
import { default as howToUsey7MRbiW003pklQnNLL_453L6O4oOuhbiQGIsvJ0oi6IRYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/howToUse.vue?macro=true";
import { default as faqsxdKSqa1YVPBEtZjkl_4qZd4bfKX_459kX_453ogLJ8uCAGYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/faqs.vue?macro=true";
import { default as edit_45data_45custom_DxkuWMDRrwhrHWKGr78oaJ_LJYFMv8tHzYlA9iURVcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/edit-data-custom.vue?macro=true";
import { default as indexwK9h8pO4jsTvr2irOnWHPu5_45Q39v8GGkm0AHaW8lB0wMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/index.vue?macro=true";
import { default as sharec6kplC1rK_8oLrn25qPUyF0WFvcNA_XiRj9mYqCoiiMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/share.vue?macro=true";
import { default as download_45pdf2CUjjBUdJe4DFKblAwgmP_IVloGYI7mIcb25U5bsOYkMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/download-pdf.vue?macro=true";
import { default as how_45to_45usex5HR6MA20cOxLJ3s0AH8GWgCSREVObi0K06kcL7Q6YgMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/how-to-use.vue?macro=true";
import { default as infomationr2kWI6IWq9qJjzrha_Alh9GGqs_1xC62CzjdsSozuWoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/infomation.vue?macro=true";
import { default as qrcodeAndLink7WhcsnjU0BxEfpN3_tBk5ZBU1nVT5iqIKFkSqK278tAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/qrcodeAndLink.vue?macro=true";
import { default as gallery0jpfX04yhrHYjC_kurzB07_45sCp1odncjUG7qz14_S7EMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/gallery.vue?macro=true";
import { default as settingDMjwMi5FH7dDd_7Wp8NpfC7qZSz6_mIxsSCEfOUsNzcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/setting.vue?macro=true";
import { default as delete_45test_45wisheHpMbenFaQPWkYl7TIy4njYHR6UR80XK7TaFmc3F_45jkMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/delete-test-wish.vue?macro=true";
import { default as how_45to_45usexFJEuzhG7nPz9ip4DZ7AVtK36m7ZmnsC7GivjwNMyW4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/how-to-use.vue?macro=true";
import { default as form_45submitted9Cp4PkjQTjze8dd9PZVnY7ml4Qd9qTyhcH7ndKlyuhoMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/form-submitted.vue?macro=true";
import { default as upload_45mobileBJvfuErY_cfRQqtQZVGakg0Q1i0MrEWhpmThYx5yZpkMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/upload-mobile.vue?macro=true";
import { default as script_45change_45richmenufp_45QqhweJfPS_rTzpPGyaFVVlhAClJtRgAep4so2qE0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/script-change-richmenu.vue?macro=true";
import { default as upload_45desktopUsshCZS4pvupOpG9R2Iuw09skTB7obWqTcRn2vGV7lYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/upload-desktop.vue?macro=true";
export default [
  {
    name: "sort",
    path: "/sort",
    meta: sortNYmoBQl_45sHCVoKp8Z3_AomLeHD1wEoV2VJcgyCyZj4gMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/sort.vue")
  },
  {
    name: "brand",
    path: "/brand",
    meta: brandPWC_45FBDR1SS25JRG1_45ANDjRpa5JmDOAnUv1diuiK_1IMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/brand.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexaGHiWLhr8sPH5xOyniSbm5iVFqgM3tFusiL4jcFgWfQMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/index.vue")
  },
  {
    name: "events",
    path: "/events",
    meta: eventsWe0_FsIS5ciOkTkrC9ALXKM3kzO7Qtd1jFd1eKFRNNoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/events.vue")
  },
  {
    name: "invite",
    path: "/invite",
    meta: inviteD2we1_muU9VbMf8HKW2ke0iJCc6RNWEAxVtl3pnqNtMMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/invite.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: uploadgrqZX_45b6NpJX4rUI_NCLFdgkhBBXa02QOWiw40_Fv3oMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/upload.vue")
  },
  {
    name: "v3-faq",
    path: "/v3/faq",
    meta: faqkNxIdEYGbPo0JJj8oKPd00YUIwg91o_MVhYFZosOM0MMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/faq.vue")
  },
  {
    name: "test-px",
    path: "/test/px",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/test/px.vue")
  },
  {
    name: "v3-book",
    path: "/v3/book",
    meta: book3TGFzpm_Bbu0j5hu_pz9qbDJO3iQTmxpBjCSzmzMUZIMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/book.vue")
  },
  {
    name: "v3-help",
    path: "/v3/help",
    meta: helpa1Bx8KU55povpFbRJ8F6NanZ8KqdClrMlKeP5A9Sx5oMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/help.vue")
  },
  {
    name: "v3-home",
    path: "/v3/home",
    meta: homervSDKEmgo0_45A1_45mRlTiprdZOqrJbxWANUe9OHB3FSHgMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/home.vue")
  },
  {
    name: "v3-idea1",
    path: "/v3/idea1",
    meta: idea1ZE_AQQ6so8VSaWaKrTVmJMsVTIPTRXhBSH12ujg9E_45EMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/idea1.vue")
  },
  {
    name: "v3",
    path: "/v3",
    meta: indexhPsh2VWbeLxtxlgXbjhu8Ln_AxNSPdmakqOhD71rFd0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/index.vue")
  },
  {
    name: "v3-login",
    path: "/v3/login",
    meta: loginfAKFbx2kWILssxYhlKfgbTwYonPW1krvVt0DUZvKw_8Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/login.vue")
  },
  {
    name: "test-blob",
    path: "/test/blob",
    meta: blobmFWETYb77oxZnHgBAfyWJOiZmDhi15UsoFHYlh_45__3IMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/test/blob.vue")
  },
  {
    name: "v3-contact",
    path: "/v3/contact",
    meta: contactjG6VmRZvfQe9LnnYAnjHFbl12lxZ3V0a5rKmBb2_45nCMMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/contact.vue")
  },
  {
    name: "v3-desktop",
    path: "/v3/desktop",
    meta: desktopWzEIh2yaDof4IUJWLXJrRjehGLt9TBsNZlXjWCit_p0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/desktop.vue")
  },
  {
    name: "v3-profile",
    path: "/v3/profile",
    meta: profilegTx7VoT_451wzPyfZ_Hx1z32EhTgSR0iKLPXznCqRVtsoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/profile.vue")
  },
  {
    name: "v3-setting",
    path: "/v3/setting",
    meta: settingyOZOogW6_qbLKVhrkXUC69qfdlHezQITffAKlv3XL7AMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/setting.vue")
  },
  {
    name: "desktop-faq",
    path: "/desktop/faq",
    meta: faqeytPGKUb2n_t_3xGITy2AvZhlFn1N2NRBeGSm9u6AJ4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/faq.vue")
  },
  {
    name: "invite copy",
    path: "/invite%20copy",
    meta: invite_32copyvLQmDD39B1RovhD6YyJ_E8FsHxmg74c3vxob_45f2D5PUMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/invite copy.vue")
  },
  {
    name: "producebook",
    path: "/producebook",
    meta: producebookLb478lddzsG4df0O4e1mmlNTMnHqNjiyQQAUJYOREO4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/producebook.vue")
  },
  {
    name: "desktop-help",
    path: "/desktop/help",
    meta: helpXa19pqxp6xjWTK7pvUYakX_45D8XLyQe6HoFRTyytaLkEMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/help.vue")
  },
  {
    name: "desktop-sort",
    path: "/desktop/sort",
    meta: sortVTRAffZw7axLCJdEBhz_vFFbuV1bvLbUSGZz6xhJoeIMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/sort.vue")
  },
  {
    name: "v3-edit-data",
    path: "/v3/edit-data",
    meta: edit_45dataXvfX9F0sUjkbXvcjGbs49IVEkjZz3CpkcPxcbWSZ6zYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/edit-data.vue")
  },
  {
    name: "v3-wish-list",
    path: "/v3/wish/list",
    meta: listeMzLeHiyJp7BY15R3NPvnk9jRp5e1TcAXNJ6_iZOyYsMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/list.vue")
  },
  {
    name: "v3-wish-main",
    path: "/v3/wish/main",
    meta: mainbkvfgkst75djnkGv74YL4CYpiDU753nboFvGH8_45ydfcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/main.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: register7TSjDF_45BFQ6OSe8w67HVtkHdTwFtWRSOdIiXVmgUM9QMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/register.vue")
  },
  {
    name: "auth-validate",
    path: "/auth/validate",
    meta: validatecAvqmc5LGwrTf5k3ChBUf_45xFe3hUgi5zM22IrYiCfWwMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/validate.vue")
  },
  {
    name: "desktop-event",
    path: "/desktop/event",
    meta: eventKUs6Jyw4ttM4FKXbhX3oPzF18KwNXpdRBfQodt6QFnAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/event.vue")
  },
  {
    name: "desktop",
    path: "/desktop",
    meta: indexAuKZ1Ndl3ZymFE8NMTxZF4vzJFXsR57iKThIXEKiJlsMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/index.vue")
  },
  {
    name: "desktop-login",
    path: "/desktop/login",
    meta: login0PVJcpWRt4FSMMmoYP_45EW_GFGxlovWT3zFFo6V0EziMMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/login.vue")
  },
  {
    name: "desktop-share",
    path: "/desktop/share",
    meta: shareQAW7aJPRFCb0gP_o9HxtbJiSixxAcdP6u_69skBefncMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/share.vue")
  },
  {
    name: "desktop-slide",
    path: "/desktop/slide",
    meta: slideYLBpaLp48LdLUmFGGDnu5uF50T7FDOGaf9O65tpu2d8Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/slide.vue")
  },
  {
    name: "desktop-terms",
    path: "/desktop/terms",
    meta: termsyjRU9tv4u2KvyA3lQ_45gG8toK2QPBar3ADb2B1AG7KYAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/terms.vue")
  },
  {
    name: "package-price",
    path: "/package/price",
    meta: priceeWJeARwYFcdJ7uj_45_Oa0mMntfGqIkcLaKIqyeKShSeUMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/package/price.vue")
  },
  {
    name: "v3-home-spare",
    path: "/v3/home-spare",
    meta: home_45spareSC3mgT_vmZ8aDUy5u_P8_D4gtYhMuOjS45QAckMTbgYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/home-spare.vue")
  },
  {
    name: "v3-how-to-use",
    path: "/v3/how-to-use",
    meta: how_45to_45useNUq0okB8ZRty4RbmFFtjWsj_7Ugd5xf9DXbZ00_45YKzkMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/how-to-use.vue")
  },
  {
    name: "v3-wish",
    path: "/v3/wish",
    meta: index4sbcDOl2Z4fYGIrOK6zf0dWujrJGX6djNrknJWEEACMMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/index.vue")
  },
  {
    name: "desktop-upload",
    path: "/desktop/upload",
    meta: uploadmQwtN2tQdMWdL5MwT0sYgGAs7OBX31_tQqyi75oy9HAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/upload.vue")
  },
  {
    name: "desktop-wishes",
    path: "/desktop/wishes",
    meta: wishesWWKwQRfMTxNakE_45gmzj7fiM_f19aqWVwbdvMtIkktBcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/wishes.vue")
  },
  {
    name: "v3-invite-user",
    path: "/v3/invite-user",
    meta: invite_45userTDV7LeoupHxsFjzyV1t_45ipQ9_45a_hIYQZ2nxcjrTdGwgMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/invite-user.vue")
  },
  {
    name: "v3-line-notify",
    path: "/v3/line-notify",
    meta: line_45notifyDcpamDmWSZWhKpPJdywH4o8nruiib8qKL2K861pIsPAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/line-notify.vue")
  },
  {
    name: "v3-wish-qrcode",
    path: "/v3/wish/qrcode",
    meta: qrcodeJ_457CWrGq9a9gxV5Yqr0DPqXVxgjw6LO9EeKKNPzj5y8Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/qrcode.vue")
  },
  {
    name: "desktop-contact",
    path: "/desktop/contact",
    meta: contactixuVJnsB2aBmcPc5J6QlseQY0GOZArPGMomR0PjRGvAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/contact.vue")
  },
  {
    name: "desktop-setting",
    path: "/desktop/setting",
    meta: settingV_hKxKwSUD1I9HsAZ8djbdkBkcvrXFLp7DgnrfC2jjkMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/setting.vue")
  },
  {
    name: "v3-exmaple-form",
    path: "/v3/exmaple-form",
    meta: exmaple_45formgHcwoCmVAlO_rKCCH0Th14ANyfdb6ilEuFf8Xholzu4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/exmaple-form.vue")
  },
  {
    name: "auth-create-user",
    path: "/auth/create-user",
    meta: create_45user7HkM_53i9GMpi5bYzt66ooFR23LqL4ZsGl2mX1P3WF8Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/create-user.vue")
  },
  {
    name: "auth-login-mobile",
    path: "/auth/login-mobile",
    meta: login_45mobileGfZ06kfSnN6__450LyfjRryvPEw61FSVwViJDERbvq2WoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/auth/login-mobile.vue")
  },
  {
    name: "desktop-edit-data",
    path: "/desktop/edit-data",
    meta: edit_45dataVcyFsGnZ7RojzWqIhnQu7dvA9l2zBdqAVN3lDDdMfMoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/edit-data.vue")
  },
  {
    name: "desktop-promptpay",
    path: "/desktop/promptpay",
    meta: promptpay8tzl1fnNTnFst6JesAg2c12Ex70CQMJEtKf_455m3OC0cMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/promptpay.vue")
  },
  {
    name: "desktop-templates",
    path: "/desktop/templates",
    meta: templatestdWOMw2BS9olDv7oJ2QB32RSITSNZ9EEdstBgq7xYMAMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/templates.vue")
  },
  {
    name: "event-brand",
    path: "/event-brand",
    meta: indexrgMmzK0ZivvcDO5JUL6iX8Ira2jZ92I41vDfKwKjEJ4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/index.vue")
  },
  {
    name: "playground-events",
    path: "/playground/events",
    meta: eventsWhLd9sMRgTDyeQoBznlVIr7til4bRaIuvvLRWJ0s2AcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/events.vue")
  },
  {
    name: "v3-promptpay-faqs",
    path: "/v3/promptpay/faqs",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/faqs.vue")
  },
  {
    name: "v3-promptpay-list",
    path: "/v3/promptpay/list",
    meta: listekvk7QFdR_45tTgCta_45AQ8VF4gmCNdX37K3PUFpG898VoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/list.vue")
  },
  {
    name: "v3-promptpay-main",
    path: "/v3/promptpay/main",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/main.vue")
  },
  {
    name: "v3-promptpay-show",
    path: "/v3/promptpay/show",
    meta: showbJ3wNRgDA2QQukQlJwZOxYysH0RiqiS0NHIm78cpaHwMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/show.vue")
  },
  {
    name: "v3-timeline",
    path: "/v3/timeline",
    meta: indexiQUal72AWM10CtAt3Xj_DRSwPuYthTmbEQZMPoQ6sDcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/timeline/index.vue")
  },
  {
    name: "v3-wish-pairEvent",
    path: "/v3/wish/pairEvent",
    meta: pairEvent7Wu6kxmwDwQswy0vxF3Gzchh_941Y_7dbsHajAD7XpYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/pairEvent.vue")
  },
  {
    name: "v3-wish-templates",
    path: "/v3/wish/templates",
    meta: templatesP08KXD2_8VWc1NYWcMnyMzvGNpcPyEJy0TidzCqp0scMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/templates.vue")
  },
  {
    name: "desktop-how-to-use",
    path: "/desktop/how-to-use",
    meta: how_45to_45useYvApndS_K0VUmsM_45BTjqcKYKPxKV3iVVf0neWZQQ_qYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/how-to-use.vue")
  },
  {
    name: "event-brand-wishes",
    path: "/event-brand/wishes",
    meta: wisheslIeJ4McZLBnIl3lIvAn5E0u9q5l3CFCHmhzFEcWCAlEMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/wishes.vue")
  },
  {
    name: "v3-promptpay",
    path: "/v3/promptpay",
    meta: indexfhnsE5XKStPOxI22t3TEVqn8eO1M8_7sh1WWxBLFjqoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/index.vue")
  },
  {
    name: "v3-wish-linkQrcode",
    path: "/v3/wish/linkQrcode",
    meta: linkQrcodevJI7pjO3ovYsuweYvIiWDq2oLecB6cuhSr75Q37_45Is4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/linkQrcode.vue")
  },
  {
    name: "desktop-producebook",
    path: "/desktop/producebook",
    meta: producebookrrBMiGaMl0Xw4aKmIqd2RPViRWMP1ViER2C2BqgAnoQMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/producebook.vue")
  },
  {
    name: "v3-edit-data-custom",
    path: "/v3/edit-data-custom",
    meta: edit_45data_45customaB_r4VKauiPZvJ4ycYwggYtT6seo5wR0kr9k_aZWcZ0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/edit-data-custom.vue")
  },
  {
    name: "v3-promptpay-qrcode",
    path: "/v3/promptpay/qrcode",
    meta: qrcodeUonxSvWx6CLUS8xWpFG62LHXsF7qYD17_HmUJbSjrh0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/qrcode.vue")
  },
  {
    name: "v3-wish-welcomePage",
    path: "/v3/wish/welcomePage",
    meta: welcomePageWkj_45HcUiKFqrF2Umip75BIk9w7bMVZz_HXm0pT8mIJsMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/welcomePage.vue")
  },
  {
    name: "desktop-wishes-spare",
    path: "/desktop/wishes-spare",
    meta: wishes_45sparej117g29Aq7iQMA0yEgCOzhrecbYWtpJxB5LWk6dr45oMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/wishes-spare.vue")
  },
  {
    name: "event-brand-favorite",
    path: "/event-brand/favorite",
    meta: favoriteGWKx4xf2QIr2RUec1qzcwyIoRwNf31xamB2YH5vXOqIMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/event-brand/favorite.vue")
  },
  {
    name: "v3-produce-book-form",
    path: "/v3/produce-book/form",
    meta: form8eHCsMbWPkhz2prMvTUH_X_45ccAz28h9Jl1ZzX3ljY2UMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/form.vue")
  },
  {
    name: "v3-produce-book-show",
    path: "/v3/produce-book/show",
    meta: showV77SbtYbRvpKb84GmA8YsN7tujHZj8g1SuE_4506N7i48Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/show.vue")
  },
  {
    name: "v3-wish-thankyouPage",
    path: "/v3/wish/thankyouPage",
    meta: thankyouPageDLmUFIuXacaLZVA5a7ZoPBU8lu1cqIXjhX1koGIy5PwMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/wish/thankyouPage.vue")
  },
  {
    name: "v3-produce-book",
    path: "/v3/produce-book",
    meta: indexWxwGVd3VNWAk_45WufdvjNdqaEmZ1MYp0kJJHVxTEvbuQMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/index.vue")
  },
  {
    name: "v3-promptpay-howToUse",
    path: "/v3/promptpay/howToUse",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/howToUse.vue")
  },
  {
    name: "v3-realtime-slides-faqs",
    path: "/v3/realtime-slides/faqs",
    meta: faqsxdKSqa1YVPBEtZjkl_4qZd4bfKX_459kX_453ogLJ8uCAGYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/faqs.vue")
  },
  {
    name: "desktop-edit-data-custom",
    path: "/desktop/edit-data-custom",
    meta: edit_45data_45custom_DxkuWMDRrwhrHWKGr78oaJ_LJYFMv8tHzYlA9iURVcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/desktop/edit-data-custom.vue")
  },
  {
    name: "v3-realtime-slides",
    path: "/v3/realtime-slides",
    meta: indexwK9h8pO4jsTvr2irOnWHPu5_45Q39v8GGkm0AHaW8lB0wMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/index.vue")
  },
  {
    name: "v3-realtime-slides-share",
    path: "/v3/realtime-slides/share",
    meta: sharec6kplC1rK_8oLrn25qPUyF0WFvcNA_XiRj9mYqCoiiMMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/share.vue")
  },
  {
    name: "v3-promptpay-download-pdf",
    path: "/v3/promptpay/download-pdf",
    meta: download_45pdf2CUjjBUdJe4DFKblAwgmP_IVloGYI7mIcb25U5bsOYkMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/download-pdf.vue")
  },
  {
    name: "v3-produce-book-how-to-use",
    path: "/v3/produce-book/how-to-use",
    meta: how_45to_45usex5HR6MA20cOxLJ3s0AH8GWgCSREVObi0K06kcL7Q6YgMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/how-to-use.vue")
  },
  {
    name: "v3-produce-book-infomation",
    path: "/v3/produce-book/infomation",
    meta: infomationr2kWI6IWq9qJjzrha_Alh9GGqs_1xC62CzjdsSozuWoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/infomation.vue")
  },
  {
    name: "v3-promptpay-qrcodeAndLink",
    path: "/v3/promptpay/qrcodeAndLink",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/promptpay/qrcodeAndLink.vue")
  },
  {
    name: "v3-realtime-slides-gallery",
    path: "/v3/realtime-slides/gallery",
    meta: gallery0jpfX04yhrHYjC_kurzB07_45sCp1odncjUG7qz14_S7EMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/gallery.vue")
  },
  {
    name: "v3-realtime-slides-setting",
    path: "/v3/realtime-slides/setting",
    meta: settingDMjwMi5FH7dDd_7Wp8NpfC7qZSz6_mIxsSCEfOUsNzcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/setting.vue")
  },
  {
    name: "playground-delete-test-wish",
    path: "/playground/delete-test-wish",
    meta: delete_45test_45wisheHpMbenFaQPWkYl7TIy4njYHR6UR80XK7TaFmc3F_45jkMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/delete-test-wish.vue")
  },
  {
    name: "v3-realtime-slides-how-to-use",
    path: "/v3/realtime-slides/how-to-use",
    meta: how_45to_45usexFJEuzhG7nPz9ip4DZ7AVtK36m7ZmnsC7GivjwNMyW4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/how-to-use.vue")
  },
  {
    name: "v3-produce-book-form-submitted",
    path: "/v3/produce-book/form-submitted",
    meta: form_45submitted9Cp4PkjQTjze8dd9PZVnY7ml4Qd9qTyhcH7ndKlyuhoMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/produce-book/form-submitted.vue")
  },
  {
    name: "v3-realtime-slides-upload-mobile",
    path: "/v3/realtime-slides/upload-mobile",
    meta: upload_45mobileBJvfuErY_cfRQqtQZVGakg0Q1i0MrEWhpmThYx5yZpkMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/upload-mobile.vue")
  },
  {
    name: "playground-script-change-richmenu",
    path: "/playground/script-change-richmenu",
    meta: script_45change_45richmenufp_45QqhweJfPS_rTzpPGyaFVVlhAClJtRgAep4so2qE0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/playground/script-change-richmenu.vue")
  },
  {
    name: "v3-realtime-slides-upload-desktop",
    path: "/v3/realtime-slides/upload-desktop",
    meta: upload_45desktopUsshCZS4pvupOpG9R2Iuw09skTB7obWqTcRn2vGV7lYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/pages/v3/realtime-slides/upload-desktop.vue")
  }
]